<div class="card-list">
  <div class="card-list__item" *ngFor="let offer of filteredJobOffers">
    <div class="card-list__body" (click)="navigateToMatches(offer.id)">
      <div nz-row>
        <div nz-col [nzSpan]="24">
          <mh-mp-job-offer-item [jobOffer]="offer" (stageUpdated)="onStageUpdated($event)"></mh-mp-job-offer-item>
        </div>
      </div>
    </div>
    <div class="card-list__actions">
      <button
        nz-button
        nzType="link"
        [disabled]="!hasReviewedStatus"
        [nz-tooltip]="'admin.edit.tooltip' | translate"
        [routerLink]="['/', 'mission-partner', 'job-offers', 'edit', offer.id]"
      >
        <span nz-icon nzType="edit"></span>
      </button>
      <ng-container *ngIf="isJobOpportunityPublishingEnabled">
        <button
          *ngIf="!offer.published"
          nz-button
          nzType="link"
          [nz-tooltip]="'job-opportunity.publish.tooltip' | translate"
          (click)="onPublish(offer)"
        >
          <span nz-icon nzType="upload" nzTheme="outline"></span>
        </button>
        <button
          *ngIf="offer.published"
          nz-button
          nzType="link"
          nzDanger
          [nz-tooltip]="'job-opportunity.unpublish.tooltip' | translate"
          (click)="onUnpublish(offer)"
        >
          <span nz-icon nzType="download" nzTheme="outline"></span>
        </button>
      </ng-container>
      <button
        nz-button
        nzType="link"
        nzDanger
        [nz-tooltip]="'admin.archive.tooltip' | translate"
        (click)="onArchive(offer)"
      >
        <span nz-icon nzType="container"></span>
      </button>
    </div>
  </div>

  <nz-empty *ngIf="!filteredJobOffers.length" nzNotFoundImage="simple"></nz-empty>
</div>
